export const BUNDLE_STATUS_CFG = {
  "Confirmed Print": {
    bg: "bg-green-100",
    text: "text-green-700",
    border: "border-green-200",
    dot: "bg-green-500",
    label: "confirmed",
  },
  New: {
    bg: "bg-blue-50",
    text: "text-blue-600",
    border: "border-blue-200",
    dot: "bg-blue-400",
    label: "new",
  },
  Cancelled: {
    bg: "bg-red-50",
    text: "text-red-600",
    border: "border-red-200",
    dot: "bg-red-400",
    label: "cancelled",
  },
  Pending: {
    bg: "bg-yellow-50",
    text: "text-yellow-700",
    border: "border-yellow-200",
    dot: "bg-yellow-400",
    label: "pending",
  },
}

export const BUNDLE_ROW_BG = {
  "Confirmed Print": "bg-green-50",
  New: "bg-white",
  Cancelled: "bg-red-50/40",
  Pending: "bg-yellow-50/40",
}
export const BUNDLE_CARD_BORDER_L = {
  "Confirmed Print": "border-l-green-400",
  New: "border-l-blue-400",
  Cancelled: "border-l-red-400",
  Pending: "border-l-yellow-400",
}
export const BUNDLE_AVATAR_COLORS = [
  "bg-blue-100 text-blue-600",
  "bg-violet-100 text-violet-600",
  "bg-emerald-100 text-emerald-600",
  "bg-amber-100 text-amber-600",
  "bg-rose-100 text-rose-600",
  "bg-cyan-100 text-cyan-600",
]

export const PAGE_SIZE = 7

export const BUNDLE_EASE = [0.25, 0.1, 0.25, 1]

export const MOCK_HOTELS = [
  { id: "h1", name: "Marriott Pendik Istanbul", country: "Туреччина", stars: 5 },
  { id: "h2", name: "Hilton Bomonti Istanbul", country: "Туреччина", stars: 5 },
  { id: "h3", name: "Radisson Blu Istanbul Asia", country: "Туреччина", stars: 4 },
  { id: "h4", name: "Kempinski Barbaros Bay Bodrum", country: "Туреччина", stars: 5 },
  { id: "h5", name: "Titanic Deluxe Bodrum", country: "Туреччина", stars: 5 },
  { id: "h6", name: "Steigenberger Al Dau Beach Hotel", country: "Єгипет", stars: 5 },
  { id: "h7", name: "Rixos Premium Seagate Sharm", country: "Єгипет", stars: 5 },
  { id: "h8", name: "Jaz Aquamarine Resort Hurghada", country: "Єгипет", stars: 5 },
  { id: "h9", name: "Siva Grand Beach Hotel", country: "Єгипет", stars: 4 },
  { id: "h10", name: "Hammamet Garden Resort & Spa", country: "Туніс", stars: 4 },
  { id: "h11", name: "Vincci Nozha Beach & Spa", country: "Туніс", stars: 4 },
]
